// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Fabelwesen „Igel": watschelt mit kleinen Wackelschritten herein, Nase wippt.
export default function Igel() {
  return (
    <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
      <g
        className="igel"
        fill="none"
        stroke="var(--tanne)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Stachelrücken */}
        <path d="M28 96 C16 84 20 58 38 48 C52 40 72 40 84 50 C94 58 96 78 90 94 Z" fill="var(--moos)" />
        {/* einzelne Stacheln */}
        <path d="M34 60 L26 52 M46 50 L42 40 M60 46 L60 36 M74 50 L80 41 M84 60 L92 54" />
        {/* Gesicht */}
        <g className="igel-kopf">
          <path d="M82 54 C96 58 106 70 111 83 C102 92 90 96 82 96 Z" fill="var(--creme)" />
          {/* Auge */}
          <circle cx="92" cy="70" r="2.5" fill="var(--tanne)" stroke="none" />
          {/* Nase (wippt) */}
          <circle className="igel-nase" cx="111" cy="83" r="3.5" fill="var(--tanne)" stroke="none" />
        </g>
        {/* Beinchen */}
        <path d="M44 96 L44 104 M60 96 L60 104 M78 96 L78 104" />
        {/* Boden */}
        <path d="M22 104 L100 104" stroke="var(--sand)" />
      </g>
    </svg>
  )
}
